export default function Spinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const cls = size === 'sm' ? 'text-base' : size === 'lg' ? 'text-3xl' : 'text-2xl';
  return (
    <div className="flex items-center justify-center">
      <i className={`ri-loader-4-line animate-spin text-navy-500 ${cls}`} />
    </div>
  );
}